<template>
    <v-content>
        <!-- Parallax -->
        <section v-if="$vuetify.breakpoint.smAndUp" class="elevation-10">
            <v-parallax src="public/dividers/div_4.png" height="400">
                <v-layout column align-center justify-center class="black--text">
                    <div v-lang.casesDes class="font-title text-xs-center"></div>
                </v-layout>
            </v-parallax>
        </section>
        <section v-else class="elevation-10">
            <v-parallax src="public/dividers/div_4_min.png" height="200">
                <v-layout column align-center justify-center class="black--text mt-5">
                    <div v-lang.casesDes class="font-title-mobile text-xs-center"></div>
                </v-layout>
            </v-parallax>
        </section>
        <!-- Content -->
        <section>
            <v-layout column wrap class="mt-3 mb-5">
                <v-container grid-list-xl>
                    <v-layout row wrap align-center justify-center>
                        <v-flex xs12 md8>
                            <v-card class="elevation-0 transparent">
                                <v-card-title v-lang.casesItem1 class="font-heading justify-center pb-0"></v-card-title>
                                <v-card-text v-lang.casesItem1Des style="text-align: justify;"></v-card-text>
                            </v-card>
                            <img src="public/images/CASE_1.png" class="mt-3" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                        </v-flex>
                        <v-flex xs12 md8>
                            <v-card class="elevation-0 transparent">
                                <v-card-title v-lang.casesItem2 class="font-heading justify-center pb-0"></v-card-title>
                                <v-card-text v-lang.casesItem2Des style="text-align: justify;"></v-card-text>
                            </v-card>
                            <img src="public/images/CASE_2.png" class="mt-3" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                        </v-flex>
                        <!-- <v-flex xs12 md8>
                            <v-card class="elevation-0 transparent">
                                <v-card-title v-lang.casesItem3 class="font-heading justify-center pb-0"></v-card-title>
                                <v-card-text v-lang.casesItem3Des style="text-align: justify;"></v-card-text>
                            </v-card>
                            <img src="public/images/CASE_3.png" class="mt-3" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                        </v-flex> -->
                    </v-layout>
                </v-container>
            </v-layout>
        </section>
        <!-- Footer -->
        <c-footer></c-footer>
    </v-content>
</template>

<script>
import CFooter from "./Footer";
export default {
  data() {
    return {};
  },
  components: {
    CFooter
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Cases.vue